module.exports = __webpack_public_path__ + "img/T5-C-xs_5.735eefff.png";